const en = {
  nav: {
    vista3d: "3D View",
    videocam: "Video Cam",
    smartdomo: "SmartDomo",
    reportSensori: "Sensor Report",
    apparati: "Appliances",
    calendario: "Calendar",
    manutenzioni: "Maintenance",
    ticket: "Tickets",
    assistente: "Assistant",
    inventario: "Inventory",
    veicoli: "Vehicles",
    setup: "Setup",
    utenti: "Users",
  },
  header: {
    title: "SmartDomo",
    subtitle: "Smart Building Management",
    admin: "Administrator",
    user: "User",
    logout: "Logout",
  },
  auth: {
    title: "Sign In",
    subtitle: "Enter your credentials to continue",
    username: "Username",
    password: "Password",
    login: "Sign In",
    loggingIn: "Signing in...",
    error: "Invalid credentials",
    userNotFound: "User not found",
    wrongPassword: "Wrong password",
    copyright: "SmartDomo - Smart Building Management",
  },
  common: {
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    search: "Search",
    filter: "Filter",
    close: "Close",
    confirm: "Confirm",
    loading: "Loading...",
    noData: "No data available",
    actions: "Actions",
    status: "Status",
    name: "Name",
    description: "Description",
    category: "Category",
    date: "Date",
    notes: "Notes",
    details: "Details",
    back: "Back",
    next: "Next",
    previous: "Previous",
    all: "All",
    active: "Active",
    inactive: "Inactive",
    online: "Online",
    offline: "Offline",
    yes: "Yes",
    no: "No",
    or: "or",
    of: "of",
    total: "Total",
    export: "Export",
    import: "Import",
    download: "Download",
    upload: "Upload",
    refresh: "Refresh",
    error: "Error",
    success: "Success",
    warning: "Warning",
    info: "Info",
  },
  dashboard: {
    title: "SmartDomo Dashboard",
    devices: "Devices",
    totalDevices: "Total Devices",
    onlineDevices: "Online Devices",
    offlineDevices: "Offline Devices",
    warnings: "Warnings",
    consumption: "Consumption",
    dailyConsumption: "Daily Consumption",
    monthlyConsumption: "Monthly Consumption",
    realTimeConsumption: "Real-Time Consumption",
    energyMonitor: "Energy Monitor",
    temperature: "Temperature",
    humidity: "Humidity",
    power: "Power",
    voltage: "Voltage",
    current: "Current",
    battery: "Battery",
    doorState: "Door State",
    open: "OPEN",
    closed: "CLOSED",
    on: "ON",
    off: "OFF",
    switchOn: "turn on",
    switchOff: "turn off",
    clickTo: "click to",
    changingState: "Changing state...",
    lastMovement: "Last movement",
    today: "Today",
    month: "Month",
    maintenance: "Maintenance",
    alerts: "Alerts",
    sensors: "Sensors",
    monitoredSensors: "Monitored Sensors",
    connectedIntegrations: "Connected Integrations",
    systemStatus: "System Status",
  },
  appliances: {
    title: "Appliance Management",
    addNew: "New Appliance",
    editAppliance: "Edit Appliance",
    brand: "Brand",
    model: "Model",
    serialNumber: "Serial Number",
    position: "Location",
    purchaseDate: "Purchase Date",
    warrantyExpiry: "Warranty Expiry",
    purchaseCost: "Purchase Cost",
    currentValue: "Current Value",
    consumption: "Hourly Consumption (kW)",
    dailyUsage: "Daily Usage Hours",
    smartPlug: "Smart Plug",
    provider: "Provider",
    noAppliances: "No appliances registered",
    linkedDevice: "Linked Device",
    invoice: "Invoice",
    documents: "Documents",
    manual: "Manual",
    photos: "Photos",
    videos: "Videos",
    instructions: "Instructions",
    serviceCenter: "Service Center",
    other: "Other",
    climate: "Climate/Heating",
    kitchen: "Kitchen",
    lighting: "Lighting",
    security: "Security",
    entertainment: "Entertainment",
    cleaning: "Cleaning",
    garden: "Garden",
    general: "General",
    warranty: "Warranty",
    warrantyActive: "Under Warranty",
    warrantyExpired: "Warranty Expired",
    deleteConfirm: "Are you sure you want to delete this appliance?",
  },
  maintenance: {
    title: "Maintenance Management",
    addNew: "New Maintenance",
    editMaintenance: "Edit Maintenance",
    type: "Type",
    scheduled: "Scheduled",
    completed: "Completed",
    inProgress: "In Progress",
    pending: "Pending",
    cancelled: "Cancelled",
    priority: "Priority",
    high: "High",
    medium: "Medium",
    low: "Low",
    assignedTo: "Assigned to",
    dueDate: "Due Date",
    completedDate: "Completion Date",
    cost: "Cost",
    noMaintenance: "No maintenance records",
    appliance: "Appliance",
    history: "History",
    deleteConfirm: "Are you sure you want to delete this maintenance record?",
  },
  tickets: {
    title: "Ticket Management",
    newTicket: "New Ticket",
    editTicket: "Edit Ticket",
    subject: "Subject",
    message: "Message",
    openTicket: "Open Ticket",
    closeTicket: "Close Ticket",
    resolved: "Resolved",
    open: "Open",
    closed: "Closed",
    inProgress: "In Progress",
    noTickets: "No tickets found",
    priority: "Priority",
  },
  calendar: {
    title: "Maintenance Calendar",
    today: "Today",
    month: "Month",
    week: "Week",
    day: "Day",
    noEvents: "No events",
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    days: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
  },
  sensors: {
    title: "Sensor Report",
    temperature: "Temperature",
    humidity: "Humidity",
    energy: "Energy",
    noData: "No Historical Data",
    collectData: "Collect Data",
    collecting: "Collecting...",
    lastHour: "Last Hour",
    last24h: "Last 24h",
    last7d: "Last 7 Days",
    last30d: "Last 30 Days",
    chart: "Chart",
    table: "Table",
    sensorType: "Sensor Type",
    readings: "Readings",
    average: "Average",
    min: "Minimum",
    max: "Maximum",
  },
  vehicles: {
    title: "Vehicle Tracking",
    noVehicles: "No vehicles found",
    speed: "Speed",
    lastUpdate: "Last Update",
    plateNumber: "Plate Number",
    moving: "Moving",
    stopped: "Stopped",
    engineOn: "Engine On",
    engineOff: "Engine Off",
  },
  matterport: {
    title: "3D Spaces",
    pois: "POI",
    sensors: "Sensors",
    spaces: "Spaces",
    addSpace: "Space",
    goToPoi: "Go to POI",
    syncCloud: "Sync Cloud",
    sdkConnected: "SDK Connected",
    sdkDisconnected: "SDK Disconnected",
    liveData: "Live Data",
    linkedDevice: "Linked",
    notSynced: "Not synced",
    noSensorLinked: "No sensor linked",
    navigating: "Navigating...",
    destination: "Destination reached!",
  },
  setup: {
    title: "Property Configuration",
    propertyName: "Property Name",
    address: "Address",
    integrations: "Integrations",
    connected: "Connected",
    disconnected: "Disconnected",
    connect: "Connect",
    disconnect: "Disconnect",
    matterportSpaceId: "Matterport Space ID",
    matterportSdkKey: "Matterport SDK Key",
    saveChanges: "Save Changes",
    saving: "Saving...",
    tokenExpired: "Token expired",
    reconnect: "Reconnect",
  },
  users: {
    title: "User Management",
    addUser: "New User",
    editUser: "Edit User",
    username: "Username",
    email: "Email",
    role: "Role",
    admin: "Administrator",
    user: "User",
    password: "Password",
    fullName: "Full Name",
    deleteConfirm: "Are you sure you want to delete this user?",
  },
  videocam: {
    title: "Camera Management",
    liveView: "Live View",
    snapshot: "Snapshot",
    refreshing: "Refreshing...",
    noCameras: "No cameras configured",
    lastCapture: "Last Capture",
  },
  assistant: {
    title: "Chat Assistant",
    placeholder: "Type a message...",
    send: "Send",
    thinking: "Thinking...",
    welcome: "SmartBuilding Assistant",
    description: "Ask anything about your appliances, maintenance, or settings.",
  },
  language: {
    it: "Italiano",
    en: "English",
    fr: "Francais",
    es: "Espanol",
    select: "Language",
  },
};

export default en;
